export default __webpack_public_path__ + "static/media/nam.8a4ec96a.jpg";